export const NO_IMAGE_URL = "/static/thorlabs/image-unavailable.webp";
